module.exports = __webpack_public_path__ + "img/globe-grey.100b72a.svg";